import { cache, navigator } from '@hotwired/turbo';

/**
 * Respects data-turbo-action on form elements to update the URL.
 * Will also clear the history to make sure navigation doesn't break JS.
 */
export default class FormActionHandler {
    constructor() {
        document.addEventListener('turbo:submit-end', this._handleFormTurboAction);
    }

    _handleFormTurboAction(event) {
        if (event.target.dataset.turboStream !== undefined && event.target.dataset.turboStream !== 'false') {
            return;
        }

        const url = new URL(event.detail?.fetchResponse?.response?.url || window.location);

        if (navigator.location.href === url.href) {
            return;
        }

        const action = event.detail?.formSubmission?.formElement?.dataset?.turboAction;

        if (action === 'advance') {
            cache.clear();
            navigator.history.push(url);

        } else if (action === 'replace') {
            cache.clear();
            navigator.history.replace(url);
        }
    }
}
